// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dd6bdb98","732":"b84f0a94","977":"f1d08183"}[chunkId] + ".chunk.js";
};